import type { Evaluation } from '@/types/global'

export type SupportedPresenceType = 'present' | 'absent'

export function isSupportedPresenceType(
  presenceType: Evaluation['presence_type']
): presenceType is SupportedPresenceType {
  return presenceType === 'present' || presenceType === 'absent'
}

export function isSupportedPresenceEvaluation<T extends Pick<Evaluation, 'presence_type'>>(
  evaluation: T | null | undefined
): evaluation is T & { presence_type: SupportedPresenceType } {
  return !!evaluation && isSupportedPresenceType(evaluation.presence_type)
}
